import React from "react"
import { Switch } from '@headlessui/react'
import { Controller, useController } from "react-hook-form"

function ToggleComponent(props) {
    const {name, rules={} ,title,control, style, type, errors, defaultValue, label,isDisabled=false, isHighLight=false,...others } = props;
    const { field, fieldState } = useController({name:name,control:control,rules:rules});
//     const { field, fieldState } = useController(props);

    let err = _.get(errors, props.name)
    function classNames(...classes) {
        return classes.filter(Boolean).join(' ')
    }

    return (
        <>
            <Controller
                name={props?.name}
                control={props?.control}
                rules={props?.rules}
                defaultValue={defaultValue}
                render={({ field: { onChange, value } }) => (
                    <>
                        <div as="div" className={`flex items-center ${isDisabled?"cursor-no-drop":"cursor-pointer"}`}>
                            <Switch
                            disabled={isDisabled ? isDisabled:false}
                                checked={(field?.value == "1" || field?.value === true) ? true : false}
                                onChange={e => {onChange(e)
                                    if(props.onChange){
                                        props.onChange(props?.name, e)
                                    }
                                }
                                }
                                className={classNames(
                                    field?.value ? `bg-bgGreen border-gray ${isHighLight && " bg-highLight" }` : 'bg-gray-200',
                                    ` relative inline-flex h-6 w-11 flex-shrink-0  rounded-full border-2 transition-colors duration-200 ease-in-out                                    `
                                )}
                            >
                                <span
                                    className={classNames(
                                        field?.value ? 'translate-x-5' : 'translate-x-0',
                                        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
                                    )}
                                />
                            </Switch>
                                <p
                                    as="span"
                                    className="ml-2"
                                    onClick={() => {
                                        onChange(!field?.value);
                                        if (props.onChange) {
                                        props.onChange(props?.name, !field?.value);
                                        }
                                    }}
                                    >
                                    <span
                                        className={
                                        field?.value
                                            ? `text-base font-normal text-gray-900`
                                            : "text-base font-normal text-gray-600"
                                        }
                                    >
                                        {label}
                                    </span>
                                </p>
                        </div>
                    </>
                )}
            />


        </>

    )
}
export default ToggleComponent